export const homeRoute = [ 'home' ];
export const ballotRoute = [ 'ballot' ];
export const ballotListRoute = [ 'ballot-list' ];
export const dashboardRoute = [ 'dashboard' ];
export const successRoute = [ 'vote-success' ];
export const idUploadRoute = [ 'id-upload' ];
export const welcomeRoute = [ 'welcome' ];
export const sessionEndedRoute = [ 'session-ended' ];
export const reviewRoute = [ 'review' ];
export const declarationRoute = [ 'declaration' ];
export const declinedRoute = [ 'declined' ];
export const signatureRoute = [ 'signature' ];
export const headshotUploadRoute = [ 'headshot-upload' ];
export const registrationRoute = [ 'registration' ];
export const registrationSuccessRoute = [ 'registration-success' ];
export const surveyRoute = [ 'survey' ];
export const petitionRoute = [ 'petition' ];
export const returnOptionsRoute = [ 'return-options' ];
export const printPageRoute = [ 'print-page' ];
export const passwordRoute = ['password'];
export const changePasswordRoute = [ 'change-password' ];
export const resetPasswordRoute = [ 'reset-password' ];
export const verifyMFARoute = [ 'verifymfa' ];
export const scanQrRoute = [ 'scan-qr' ];
export const manualOrgKeyRoute = [ 'org-key' ];
export const verifyWithOrgKeyRoute = [ 'verify-with-org-key' ];
export const pollDecisionRoute = [ 'poll' ];
export const pollResultsListRoute = [ 'poll-results-list' ];
export const pollResultsRoute = [ 'poll-results' ];
export const changeMfaRoute = ['change-mfa'];
export const scanMfaQRroute = ['scan-mfa-qr'];

export const routesByDocumentType = {
  id: idUploadRoute,
  headshot: headshotUploadRoute,
  declaration: declarationRoute,
};
